import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, User, HeartPulse } from "lucide-react";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { name: "Home", path: "/", icon: Home, activeColor: "text-blue-600", activeBg: "bg-blue-100/60" },
    { name: "Donors", path: "/donors", icon: HeartPulse, activeColor: "text-red-600", activeBg: "bg-red-100/60" },
    { name: "Profile", path: "/profile", icon: User, activeColor: "text-emerald-600", activeBg: "bg-emerald-100/60" }
  ];

  return (
    // 🔥 Strict Fixed Positioning with Safe Area & High Z-Index 🔥
    <div 
      className="fixed bottom-0 left-0 right-0 w-full z-[9999]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {/* 🔥 Reduced paddings: pt-2 pb-2 sm:pb-3 🔥 */}
      <div className="bg-white/85 backdrop-blur-2xl border-t border-gray-100 shadow-[0_-10px_40px_rgba(0,0,0,0.08)] rounded-t-[1.5rem] px-6 pt-2 pb-2 sm:pb-3">
        
        <div className="max-w-md mx-auto flex justify-between items-center relative">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;

            return (
              <button
                key={item.name}
                onClick={() => navigate(item.path)}
                // 🔥 Reduced height: h-12 instead of h-14 🔥
                className={`relative flex flex-col items-center justify-center w-16 h-12 rounded-xl transition-colors duration-300 ${
                  isActive ? item.activeColor : "text-slate-400 hover:text-slate-600"
                }`}
              >
                {isActive && (
                  <motion.div
                    layoutId="activeNavPill"
                    className={`absolute inset-0 ${item.activeBg} rounded-xl -z-10`}
                    transition={{ type: "spring", stiffness: 300, damping: 25 }}
                  />
                )}

                <motion.div
                  whileTap={{ scale: 0.85 }}
                  className="flex flex-col items-center gap-0.5 mt-0.5"
                >
                  {/* 🔥 Reduced icon size slightly 🔥 */}
                  <Icon 
                    size={isActive ? 22 : 20} 
                    strokeWidth={isActive ? 2.5 : 2} 
                    className={`transition-all duration-300 ${isActive ? '-translate-y-0.5' : ''}`} 
                  />
                  {/* 🔥 Made text smaller 🔥 */}
                  <span className={`text-[9px] tracking-wide transition-all duration-300 ${
                    isActive ? "font-black opacity-100" : "font-semibold opacity-80"
                  }`}>
                    {item.name}
                  </span>
                </motion.div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}